import { atom } from 'recoil';
import { Locale } from '@enmon/commons';

export const localeAtom = atom<Locale>({
  key: 'app/LanguageProvider/localeState',
  default: Locale.CS,
});
